import React, { Component } from 'react'
import TutorialCard from '../../Components/TutorialCard'
import Navbar from '../../Components/Navbar'
export default class MirrorImage extends Component {
    render() {
        return (
            <>
                <header>
                    <Navbar />
                </header>
                <main className="main">
                    <TutorialCard title="Coming Soon"></TutorialCard>
                </main>
            </>
        )
    }
}
